import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {SubcategoryDTO} from '../model/subcategoryDTO';
import {AddSubcategoryDTO} from '../model/addSubcategoryDTO';
import {GroupedSubcategoriesDTO} from '../model/groupedSubcategoriesDTO';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'subcategory';

  constructor(private http: HttpClient) { }

  getSubcategories() {
    return this.http.get<Array<SubcategoryDTO>>(`${this.path}`);
  }

  addSubcategory(sub: AddSubcategoryDTO) {
    return this.http.post<SubcategoryDTO>(`${this.path}`, sub);
  }

  deleteSubcategory(id) {
    return this.http.delete<void>(`${this.path}/${id}`);
  }

  getGroupedSubcategories() {
    return this.http.get<GroupedSubcategoriesDTO>(`${this.path}/grouped`);
  }
}
